import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
import { Blossom } from "@blossom-carousel/core";

gsap.registerPlugin(scrollTrigger);

export class TeaserCards {
	constructor() {
		this.teaserCardsBlocks = document.querySelectorAll(".teaser-cards-block");

		this.mm = gsap.matchMedia();

		this.teaserCardsBlocks.forEach((block) => {
			this.initCarousel(block);
			this.revealAnimation(block);
			this.scrollAnimation(block);
			this.focusFix(block);
		});
	}

	initCarousel(block) {
		const teaserCardsWrap = block.querySelector(
			".teaser-cards-block__teaser-cards-wrap"
		);

		const blossom = Blossom(teaserCardsWrap);

		blossom.init();

		// Prevent drag on anchor elements and handle card clicks
		const teaserCards = teaserCardsWrap.querySelectorAll(".teaser-card");

		teaserCards.forEach((card, index) => {
			const anchor = card.querySelector("a");

			// Prevent dragstart on the anchor
			if (anchor) {
				anchor.addEventListener("dragstart", (e) => {
					e.preventDefault();
				});
			}

			// Track mouse movement on the entire card
			let startX = 0;
			let startY = 0;
			let hasMoved = false;
			let isMouseDown = false;
			const moveThreshold = 5; // pixels

			card.addEventListener("mousedown", (e) => {
				startX = e.clientX;
				startY = e.clientY;
				hasMoved = false;
				isMouseDown = true;
			});

			card.addEventListener("mousemove", (e) => {
				if (!isMouseDown) return;

				const deltaX = Math.abs(e.clientX - startX);
				const deltaY = Math.abs(e.clientY - startY);
				if (deltaX > moveThreshold || deltaY > moveThreshold) {
					hasMoved = true;
				}
			});

			card.addEventListener("mouseup", (e) => {
				isMouseDown = false;
			});

			card.addEventListener("click", (e) => {
				if (hasMoved) {
					e.preventDefault();
					e.stopPropagation();
				} else if (anchor) {
					// If it's a clean click, trigger the anchor
					window.location.href = anchor.href;
				}
			});
		});
	}

	revealAnimation(block) {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			return;
		}

		const teaserCardsInner = block.querySelector(
			".teaser-cards-block__teaser-cards-inner"
		);

		gsap
			.timeline({
				scrollTrigger: {
					trigger: block,
					start: "top bottom",
					end: "center 75%",
					scrub: 0.25,
				},
				defaults: {
					ease: "power1.out",
					duration: 1,
				},
			})

			.from(teaserCardsInner, {
				x: 200,
			});
	}

	scrollAnimation(block) {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			return;
		}

		const textWrap = block.querySelector(".teaser-cards-block__text-wrap");
		const teaserCardsWrap = block.querySelector(
			".teaser-cards-block__teaser-cards-wrap"
		);
		const firstTeaserCard = block.querySelector(".teaser-cards__item");

		this.mm.add("(min-width: 1000px)", () => {
			gsap
				.timeline({
					scrollTrigger: {
						trigger: firstTeaserCard,
						scroller: teaserCardsWrap,
						horizontal: true,
						start: 0,
						end: "+=300",
						scrub: 0.25,
					},
					defaults: {
						ease: "none",
						duration: 1,
					},
				})

				.to(textWrap, {
					opacity: 0,
				});
		});
	}

	focusFix(block) {
		// When moving the focus from the first card to the button in the text,
		// the carousel doesn't scroll back all the to the start, overlaying the text.
		// This listener scrolls the carousel back to the start when focusing the button.

		const textWrap = block.querySelector(".teaser-cards-block__text-wrap");
		const teaserCardsWrap = block.querySelector(
			".teaser-cards-block__teaser-cards-wrap"
		);
		const focusableElementInText = textWrap.querySelector("a");

		focusableElementInText?.addEventListener("focus", () => {
			teaserCardsWrap.scrollTo({ left: 0 });
		});
	}
}
